var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignLanguageAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.74285 3.5C8.74285 2.67157 9.43013 2 10.2779 2C11.1257 2 11.813 2.67157 11.813 3.5V9.75C11.813 9.88807 11.9275 10 12.0688 10C12.2101 10 12.3247 9.88807 12.3247 9.75V4.5C12.3247 3.67157 13.0119 3 13.8597 3C14.7075 3 15.3948 3.67157 15.3948 4.5V9.75L17.7516 10.3897C19.0804 10.7504 20 11.9326 20 13.2803V17C20 19.7614 17.7091 22 14.8831 22H12.6398C10.2757 22 8.13905 20.6233 7.20779 18.5L4.17346 12.1464C3.84477 11.4582 3.99183 10.6425 4.54143 10.1054C5.38195 9.28413 6.78588 9.44037 7.41588 10.4253L8.74285 12.5V3.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignLanguageAlt);
export default __webpack_public_path__ + "static/media/sign-language-alt.1a43272b4d6d44ca7013ebf336c1da49.svg";
export { ForwardRef as ReactComponent };